'use client';
import Marquee from 'react-fast-marquee';
import { SectionContainer } from '../component/SectionContainer';
import { MarqueeItem } from '../type';
import { getCMSIntlVal } from '../utils/common';
import { useLocale } from 'use-intl';
import { useMedia } from '@ssv-website/hooks';
import { useMemo } from 'react';
import Image from '../../../image';

interface MarqueeContainerProps {
  list: MarqueeItem[];
  direction?: 'left' | 'right';
  /** 是否启用跑马灯 */
  isMobileMarquee?: boolean;
}
const MarqueeContainer = ({
  list,
  direction = 'left',
  isMobileMarquee = false,
}: MarqueeContainerProps) => {
  const locale = useLocale();
  const isMobile = useMedia('mobile');
  // PC端
  if (!isMobile) {
    // 如果数据不够15个，则重复
    while (list.length <= 15) {
      list = list.concat(list);
    }
  }
  // 移动端跑马灯
  if (isMobile && isMobileMarquee) {
    while (list.length <= 6) {
      list = list.concat(list);
    }
  }

  const Warpper = ({ className }: { className?: string }) => {
    return (
      <div
        className={`w-fit grid ${className}`}
        style={{
          gridTemplateColumns: isMobile
            ? `repeat(${list.length}, minmax(min-content, max-content))`
            : `repeat(${list.length}, minmax(0, 1fr))`,
        }}
      >
        {list?.map((item, index) => {
          const desc = getCMSIntlVal(item, 'desc', locale);
          return (
            <div
              key={index}
              onClick={() => window.open(item.link, '_blank')}
              className="overflow-hidden group relative flex flex-col cursor-pointer mx-[6px] mobile:mx-[2px]"
            >
              <div className="pc:group-hover:scale-110 pc:transition-all pc:duration-700 object-cover w-[480px] h-[270px] mobile:!w-[180px] mobile:!h-[101px]">
                <Image
                  loading="lazy"
                  fill={true}
                  src={item.imgUrl}
                  objectFit="cover"
                  alt={'Review Image'}
                />
              </div>

              {desc && (
                <div
                  className="absolute left-0 bottom-0 w-full p-5 z-10 text-white/90 h-[127px] flex flex-col justify-end opacity-0 mobile:hidden pc:group-hover:opacity-100 pc:transition-all pc:duration-700"
                  style={{
                    background:
                      'linear-gradient(180deg, rgba(0, 7, 44, 0.00) 0%, rgba(0, 7, 44, 0.60) 90%)',
                  }}
                >
                  <p className="line-clamp-2 text-2xl break-all">{desc}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };
  return (
    <div
      className={`h-[270px] mb-3 last:mb-0 mobile:h-[101px] mobile:mb-1 mobile:overflow-x-scroll ${
        isMobileMarquee ? '' : 'mobile:ml-5'
      }  scrollbar-hidden`}
      style={{
        WebkitOverflowScrolling: 'touch',
      }}
    >
      {isMobile && !isMobileMarquee ? (
        <Warpper className={`mobile:mr-5`} />
      ) : (
        <Marquee
          className="w-full"
          speed={20}
          pauseOnHover
          direction={direction}
        >
          <Warpper className={`${isMobileMarquee ? '' : 'mobile:mr-5'}`} />
        </Marquee>
      )}
    </div>
  );
};

interface MeetingReviewSectionProps {
  data: MarqueeItem[];
  title: string;
}
export default function MeetingReviewSection({
  data,
  title,
}: MeetingReviewSectionProps) {
  // const [leftList, rightList] = useMemo(() => {
  //   const leftList = data.slice(0, data.length / 2);
  //   const rightList = data.slice(data.length / 2);
  //   return [leftList, rightList];
  // }, [data]);
  return (
    <SectionContainer title={title} childrenFullWidth>
      <MarqueeContainer list={data} />
      {/* <MarqueeContainer list={rightList} direction="right" /> */}
    </SectionContainer>
  );
}

interface MeetingReviewImageSectionProps {
  data: MarqueeItem[];
  title: string;
}
export function MeetingReviewImageSection({
  data,
  title,
}: MeetingReviewImageSectionProps) {
  const [leftList, rightList] = useMemo(() => {
    const leftList = data.slice(0, data.length / 2);
    const rightList = data.slice(data.length / 2);
    return [leftList, rightList];
  }, [data]);
  return (
    <SectionContainer title={title} childrenFullWidth>
      <MarqueeContainer list={leftList} isMobileMarquee={true} />
      <MarqueeContainer
        list={rightList}
        direction="right"
        isMobileMarquee={true}
      />
    </SectionContainer>
  );
}
